<template>
  <div style="height: 100%">
    <div style="width: 100%">
            <el-row class="filter-bar" ref="filterBar">
          <el-input v-model="formDatas.goodsName" style="width: 180px;" size="mini" placeholder="商品名称" clearable></el-input>
          <el-select v-model="formDatas.asId" size="mini" clearable filterable placeholder="归属商户" style="width: 200px;" @change="partserch">
            <el-option v-for="s in shopOptions" :key="s.asId" :label="s.asName" :value="s.asId"></el-option>
          </el-select>
          <el-select v-model="formDatas.goodsStatus" size="mini" clearable placeholder="状态" style="width: 110px;" @change="partserch">
            <el-option label="上架" :value="1"></el-option>
            <el-option label="下架" :value="2"></el-option>
          </el-select>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch" style="">搜索</el-button>
          <el-button type="success" size="mini" style="" @click="Out">导出</el-button>
          
            <el-button type="primary" size="mini" style=" " @click="BoxOpen">新增</el-button>
          </div>
        </el-row>
        </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            row-key-field-name="goodsId" style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <!-- 新增/编辑 -->
      <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑商品' : '新增商品'" :before-close="handleClose"
        :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer" size="35%">
        <div class="demo-drawer__content" style="height: 90%;">
          <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
            <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 30px 15px;overflow-x: hidden;">
              <el-form-item label="归属商户(一户一品,创建后不可改)" prop="asId">
                <el-select v-model="form.asId" filterable :disabled="edit" style="width: 80%;" placeholder="搜索选择商户">
                  <el-option v-for="s in shopOptions" :key="s.asId" :label="s.asName + '(' + s.asId + ')'" :value="s.asId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品名称" prop="goodsName">
                <el-input v-model="form.goodsName" style="width: 80%;" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="商品价格(分)" prop="goodsPrice">
                <el-input-number v-model="form.goodsPrice" :min="11" style="width: 80%;"></el-input-number>
                <div style="font-size:12px;color:#909399;">=到店商品价=券使用门槛(微信下限0.11元),券面额自动=价格-0.01元,用户到店实付0.01元;权益金按分账比例在领券时自动计算</div>
              </el-form-item>
              <el-form-item label="分账比例覆盖(万分比)" prop="goodsShareRatio">
                <el-input-number v-model="form.goodsShareRatio" :min="1" :max="10000" style="width: 80%;"></el-input-number>
                <div style="font-size:12px;color:#909399;">不填按商户分账配置自动算;单张权益金=券面额x10000÷比例(向上取整),领券时锁定。如面额70元比例7000(70%)=单张100元权益金</div>
              </el-form-item>
              <el-form-item label="商品编码(不填默认GOODS+id,创建批次后勿改)">
                <el-input v-model="form.goodsSku" style="width: 80%;" placeholder="字母/数字/下划线"></el-input>
              </el-form-item>
              <el-form-item label="商品图片">
                <my-uploadOnly ref="upload" @fileChange="fileChange" :filearr="fileList" :limit="10"
                  style="margin: 10px 5px 5px;" @removeAfter="removeAfter"></my-uploadOnly>
              </el-form-item>
              <el-form-item label="商品描述">
                <el-input v-model="form.goodsDes" type="textarea" :rows="3" style="width: 80%;" placeholder="请输入"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="demo-drawer__footer" style="margin-top: 10px;">
          <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
          <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">确 定</el-button>
        </div>
      </el-drawer>
      <!-- 创建批次 -->
      <el-drawer :wrapperClosable="false" title="创建微信单品券批次" :before-close="stockClose"
        :visible.sync="stockDialog" direction="rtl" custom-class="demo-drawer" ref="drawer2" size="40%">
        <div class="demo-drawer__content" style="height: 90%;">
          <el-form label-position="top" style="height:100%">
            <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 30px 15px;overflow-x: hidden;">
              <el-form-item label="商品">
                <el-input :value="(stockForm.goodsName || '') + '(' + ((stockForm.goodsPrice || 0) / 100).toFixed(2) + '元)'" disabled style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item label="归属商户">
                <el-input :value="(stockForm.asName || '') + '(' + (stockForm.asId || '-') + ')'" disabled style="width: 80%;"></el-input>
              </el-form-item>
              <el-form-item label="批次发放上限(张,最少6张)">
                <el-input-number v-model="stockForm.maxCoupons" :min="6" style="width: 80%;"></el-input-number>
              </el-form-item>
              <el-form-item label="单用户可领个数">
                <el-input-number v-model="stockForm.maxCouponsPerUser" :min="1" :max="60" style="width: 80%;"></el-input-number>
              </el-form-item>
              <el-form-item label="批次可用天数(1-90)">
                <el-input-number v-model="stockForm.availableDays" :min="1" :max="90" style="width: 80%;"></el-input-number>
              </el-form-item>
              <div style="font-size:12px;color:#909399;margin-bottom:10px;">券面额自动=商品价-0.01元,门槛=商品价;预充值模式:创建后须到批次管理页激活(需服务商营销账户已充值),激活后用户才可兑换</div>
            </div>
          </el-form>
        </div>
        <div class="demo-drawer__footer" style="margin-top: 10px;">
          <el-button @click="stockClose()" style="margin-left: 20%;">取 消</el-button>
          <el-button type="primary" @click="stockSure" style="margin-left: 150px;">确 定</el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefGoodsList, addAjefGoods, updateAjefGoods, updateAjefGoodsStatus, deleteAjefGoods, getAjefShopListQuick, createWxCouponStock } from "../../api/api";
export default {
  name: "GoodsSku",
  data() {
    return {
      dialog: false,
      edit: false,
      form: {},
      //创建批次
      stockDialog: false,
      stockForm: {},
      fileList: [],
      rules: {
        asId: [{ required: true, message: '请选择归属商户', trigger: 'change' }],
        goodsName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        goodsPrice: [{ required: true, message: '请输入商品价格(分)', trigger: 'blur' }],
      },
      shopOptions: [],
      tableLoading: false,
      totalCount: 0,
      tableHight: 520,
      tableData: [],
      cellStyleOption: {
        headerCellClass: ({ rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      formDatas: {
        goodsName: '',
        asId: null,
        goodsStatus: null,
        currentPage: 1,
        pageSize: 20
      },
      columns: [
        { field: "", key: "a", title: "序号", width: 50, align: "center", renderBodyCell: ({ rowIndex }, h) => { return ++rowIndex; } },
        { field: "goodsId", key: "goodsId", title: "商品id", width: 80, align: "center" },
        { field: "goodsImage", key: "goodsImage", title: "图片", width: 90, align: "center",
          renderBodyCell: ({ row }, h) => {
            return row.goodsImage ? <el-image style="width: 40px; height: 40px" src={row.goodsImage} fit="cover" preview-src-list={[row.goodsImage]}></el-image> : <span>-</span>;
          } },
        { field: "goodsName", key: "goodsName", title: "商品名称", width: 200, align: "center", ellipsis: true },
        { field: "goodsPrice", key: "goodsPrice", title: "价格(分)", width: 100, align: "center",
          renderBodyCell: ({ row }, h) => {
            return <span>{row.goodsPrice}<br /><span style="color:#909399;font-size:12px;">券{(row.goodsPrice - 1)}/门槛{row.goodsPrice}</span></span>;
          } },
        { field: "goodsShareRatio", key: "goodsShareRatio", title: "分账比例", width: 100, align: "center",
          renderBodyCell: ({ row }, h) => {
            return <span>{row.goodsShareRatio ? (row.goodsShareRatio / 100).toFixed(2) + '%' : <span style="color:#909399;">按商户配置</span>}</span>;
          } },
        { field: "goodsSku", key: "goodsSku", title: "商品编码", width: 140, align: "center" },
        { field: "asName", key: "asName", title: "归属商户", width: 200, align: "center", ellipsis: true,
          renderBodyCell: ({ row }, h) => {
            return <span>{row.asName || '-'}<br />({row.asId || '-'})</span>;
          } },
        { field: "goodsStatus", key: "goodsStatus", title: "状态", width: 90, align: "center",
          renderBodyCell: ({ row }, h) => {
            return <el-tag size="mini" type={row.goodsStatus === 1 ? 'success' : 'info'}>{row.goodsStatus === 1 ? '上架' : '下架'}</el-tag>;
          } },
        { field: "goodsDes", key: "goodsDes", title: "描述", width: 150, align: "center", ellipsis: true },
        { field: "createtime", key: "createtime", title: "创建时间", width: 150, align: "center" },
        { field: "", key: "d", title: "操作", width: 220, align: "center", fixed: 'right',
          renderBodyCell: ({ row }, h) => {
            return (
              <div>
                {!row.hasStock ? (
                  <el-button type="text" size="mini" style="color: #409EFF" on-click={() => this.stockOpen(row)}>创建批次</el-button>
                ) : null}
                <el-button type="text" size="mini" on-click={() => this.editorgan(row)}>编辑</el-button>
                <el-button type="text" size="mini" on-click={() => this.upDown(row)}>{row.goodsStatus === 1 ? '下架' : '上架'}</el-button>
                <el-button type="text" size="mini" style="color: #F56C6C" on-click={() => this.deleteRow(row)}>删除</el-button>
              </div>
            );
          } },
      ],
    };
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = calcTableHeight(this, this.windheight, 140);
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      const params = { ...this.formDatas };
      if (params.goodsName === '') delete params.goodsName;
      if (params.asId === null || params.asId === '') delete params.asId;
      getAjefGoodsList(params).then((res) => {
        this.tableLoading = false;
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    BoxOpen() {
      this.edit = false;
      this.form = { asId: null, goodsName: '', goodsPrice: undefined, goodsShareRatio: undefined, goodsSku: '', goodsDes: '' };
      this.fileList = [];
      this.loadShops();
      this.dialog = true;
    },
    editorgan(row) {
      this.edit = true;
      this.form = {
        goodsId: row.goodsId,
        asId: row.asId,
        goodsName: row.goodsName,
        goodsPrice: row.goodsPrice,
        goodsShareRatio: row.goodsShareRatio,
        goodsSku: row.goodsSku,
        goodsDes: row.goodsDes,
      };
      this.fileList = row.goodsImage ? [{ url: row.goodsImage, name: row.goodsImage }] : [];
      this.loadShops();
      this.dialog = true;
    },
    //归属商户选项(一次拉全量本地过滤)
    loadShops() {
      if (this.shopOptions.length === 0) {
        getAjefShopListQuick({ pageSize: 0 }).then(res => {
          this.shopOptions = res.data || [];
        });
      }
    },
    // ===== 创建批次 =====
    stockOpen(row) {
      this.stockForm = {
        goodsId: row.goodsId, asId: row.asId,
        goodsName: row.goodsName, goodsPrice: row.goodsPrice, asName: row.asName,
        maxCoupons: 1000, maxCouponsPerUser: 1, availableDays: 90
      };
      this.stockDialog = true;
    },
    stockClose() {
      this.stockDialog = false;
    },
    stockSure() {
      this.$confirm('确认为商品「' + this.stockForm.goodsName + '」创建微信单品券批次？', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        this.openLoading();
        createWxCouponStock(this.stockForm).then(() => {
          this.loadings.close();
          this.$message.success('批次创建成功,请到批次管理页激活');
          this.stockClose();
          this.getList();
        }).catch(() => {
          this.loadings.close();
        });
      });
    },
    handleClose() {
      this.dialog = false;
    },
    fileChange(file) {
      if (file && file.length > 0) {
        this.form.goodsImage = file[file.length - 1];
      }
    },
    removeAfter() {
      this.form.goodsImage = '';
    },
    SureBtn() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$confirm(this.edit ? '确认编辑该商品？(改价格不影响已建批次)' : '确认新增该商品？', '提示', {
            confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
          }).then(() => {
            if (this.edit) {
              updateAjefGoods(this.form).then((res) => {
                this.$message.success('编辑成功');
                this.handleClose();
                this.getList();
              });
            } else {
              addAjefGoods(this.form).then((res) => {
                this.$message.success('新增成功');
                this.handleClose();
                this.getList();
              });
            }
          });
        }
      });
    },
    upDown(row) {
      const target = row.goodsStatus === 1 ? 2 : 1;
      this.$confirm(`确认${target === 1 ? '上架' : '下架'}商品「${row.goodsName}」？`, '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        updateAjefGoodsStatus({ goodsId: row.goodsId, goodsStatus: target }).then((res) => {
          this.$message.success('操作成功');
          this.getList();
        });
      });
    },
    deleteRow(row) {
      this.$confirm(`确认删除商品「${row.goodsName}」？(有子商户绑定时会被拦截)`, '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        deleteAjefGoods({ goodsId: row.goodsId }).then((res) => {
          this.$message.success('删除成功');
          this.getList();
        });
      });
    },
    Out() {
      var s = qs.stringify({ goodsName: this.formDatas.goodsName });
      this.openLoading();
      var that = this;
      axios({
        method: 'post',
        url: config.baseURL + '/ajef-goods/exportAjefGoods',
        data: s,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'useref': window.localStorage.getItem('Qy_token')
        }
      }).then(res => {
        that.loadings.close();
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        const objectUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.setAttribute('href', objectUrl);
        a.setAttribute('download', '商品SKU.xlsx');
        a.click();
        URL.revokeObjectURL(objectUrl);
      }).catch(() => {
        that.loadings.close();
      });
    },
    openLoading() {
      this.loadings = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
  },
};
</script>

<style scoped>
</style>
